import * as VueRouter from 'vue-router';

import Home from '@/views/Home.vue'
import Error from '@/views/Error.vue'
import Default from '@/views/Default.vue'
import News from '@/views/News.vue'
import Article from '@/views/Article.vue'

import { alternativeLanguage } from '@/utils';

const multilanguageroutes = [
  { path: '/', redirect: to => { if(document.documentElement.lang) return document.documentElement.lang;}},
  {
    name: 'Language',
    path: '/:language',
    children: [
      { name: 'Home', path: '', component: Home },
      { name: 'News', path: 'ajankohtaista', component: News },
      { name: 'Article', path: 'ajankohtaista/:article', component: Article },
      { name: 'Error', path: 'error', component: Default },
      { name: 'Default', path: ':primi', component: Default },
    ]
  }
]

export const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes: multilanguageroutes,
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    }
  }
})
